import { c as _c } from "react/compiler-runtime";
import React from "react";
import { DropRequirementType } from "./CreateDropContentRequirements";
import { Tooltip } from "react-tooltip";
interface CreateDropContentRequirementsItemProps {
  readonly isValid: boolean;
  readonly requirementType: DropRequirementType;
  readonly missingItems: string[];
  readonly disabled: boolean;
  readonly onOpenMetadata: () => void;
  readonly setFiles: (files: File[]) => void;
}
const CreateDropContentRequirementsItem: React.FC<CreateDropContentRequirementsItemProps> = t0 => {
  const $ = _c(31);
  const {
    isValid,
    requirementType,
    missingItems,
    onOpenMetadata,
    setFiles,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [DropRequirementType.MEDIA]: "Media",
      [DropRequirementType.METADATA]: "Metadata"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  let t2;
  if ($[1] !== onOpenMetadata || $[2] !== requirementType || $[3] !== setFiles) {
    t2 = () => {
      if (requirementType === DropRequirementType.METADATA) {
        onOpenMetadata();
      } else {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.multiple = true;
        fileInput.accept = "image/*,audio/*,video/*";
        fileInput.onchange = e => {
          const target = e.target as HTMLInputElement;
          if (target.files) {
            setFiles(Array.from(target.files));
          }
        };
        fileInput.click();
      }
    };
    $[1] = onOpenMetadata;
    $[2] = requirementType;
    $[3] = setFiles;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClick = t2;
  let t3;
  if ($[5] !== disabled || $[6] !== isValid) {
    t3 = () => {
      if (disabled) {
        return "tw-opacity-50 tw-cursor-not-allowed";
      }
      return isValid ? "tw-text-green" : "tw-text-[#FEDF89]";
    };
    $[5] = disabled;
    $[6] = isValid;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getButtonColorClass = t3;
  const t4 = `tw-flex tw-bg-transparent tw-border-none tw-items-center tw-gap-x-1.5 ${getButtonColorClass()}`;
  const t5 = `requirement-${requirementType}-${isValid}`;
  let t6;
  if ($[8] !== disabled || $[9] !== isValid) {
    t6 = isValid ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={disabled ? "currentColor" : "green"} aria-hidden="true" className="tw-size-4"><path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" aria-hidden="true" stroke={disabled ? "currentColor" : "yellow"} className="tw-size-4"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" /></svg>;
    $[8] = disabled;
    $[9] = isValid;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = LABELS[requirementType];
  let t8;
  if ($[11] !== t7) {
    t8 = <span className="tw-text-xs">{t7}</span>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== disabled || $[14] !== handleClick || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t8) {
    t9 = <button className={t4} onClick={handleClick} type="button" disabled={disabled} data-tooltip-id={t5}>{t6}{t8}</button>;
    $[13] = disabled;
    $[14] = handleClick;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `requirement-${requirementType}-${isValid}`;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== isValid || $[22] !== missingItems || $[23] !== requirementType) {
    t12 = <div className="tw-p-2 tw-bg-iron-900 tw-rounded-md tw-shadow-lg">{isValid ? <p className="tw-text-green tw-text-sm tw-font-medium">All requirements met. Good job!</p> : <div><p className="tw-text-[#FEDF89] tw-font-medium tw-mb-2">{requirementType === DropRequirementType.MEDIA ? "Missing required media:" : "Missing required metadata:"}</p><ul className="tw-list-disc tw-list-inside tw-text-white">{missingItems.map(_temp)}</ul><p className="tw-text-iron-300 tw-mt-2 tw-text-sm">Please add the missing {requirementType.toLowerCase()} to proceed.</p></div>}</div>;
    $[21] = isValid;
    $[22] = missingItems;
    $[23] = requirementType;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <Tooltip id={t10} style={t11}>{t12}</Tooltip>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t9) {
    t14 = <>{t9}{t13}</>;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export default CreateDropContentRequirementsItem;
function _temp(item) {
  return <li key={item} className="tw-capitalize">{item}</li>;
}